import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import StorageUtils from "@services/storage";
import { type TempKeys, tempTemplate } from "@services/storage/storeTemplate";
import type { RootState } from "../../../store";
export const storeName = "temp";

export const templateState = tempTemplate();

export const initialState = tempTemplate();

export interface Action {
	name?: TempKeys;
	value: any;
}

export const tempSlice = createSlice({
	name: storeName,
	initialState,
	reducers: {
		reset: (state) => {
			// logger.debug(namespace + "->" + reset.name, "Reset state");
			return { ...initialState };
		},
		hydrate: (state, action: PayloadAction<Action>) => {
			// logger.debug(namespace + "->" + hydrate.name, "Hydrating state");
			return { ...initialState, ...action.payload.value };
		},
		set: (state, action: PayloadAction<Action>) => {
			if (action.payload.name) {
				state[action.payload.name] = action.payload.value as never;
				// logger.debug(namespace + "->" + set.name, `Setting state temp state`);
			}
		},
		save: (state) => {
			// logger.debug(namespace + "->" + save.name, "Saving state");
			for (const key in state) {
				StorageUtils.saveToStorage({
					type: "local",
					store: storeName,
					key,
					value: state[key as keyof typeof state],
				});
			}
		},
	},
});

export const { actions, reducer } = tempSlice;

export const { reset, hydrate, set, save } = actions;

export const tempSelector = (state: RootState) => state.temp;
